import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserWorkAttendanceApiService } from './user-work-attendance.api.service';
import { UserWorkAttendanceEffects } from './user-work-attendance.effects';
import {
  userWorkAttendanceReducer,
  userWorkAttendanceInitialState,
  IUserWorkAttendanceState,
} from './user-work-attendance.reducer';
import { UserWorkAttendanceService } from './user-work-attendance.service';
import { userWorkAttendanceFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IUserWorkAttendanceState>(
      userWorkAttendanceFeatureKey,
      userWorkAttendanceReducer,
      {
        initialState: userWorkAttendanceInitialState,
      },
    ),
    EffectsModule.forFeature([UserWorkAttendanceEffects]),
  ],
  providers: [UserWorkAttendanceApiService, UserWorkAttendanceService],
})
export class StoreUserWorkAttendanceModule {}
